// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3446":"496b55a2083a97a6","7046":"2d69227f4e3a6be3","7679":"f4a15c4843ade3b8"}[chunkId] + ".css";
};